<script lang="ts">
import type { Snippet } from "svelte";

/** A key phrase in body copy, marked like Lens's `Highlight` (secondary variant). */
let { children }: { children: Snippet } = $props();
</script>

<mark class="mark">{@render children()}</mark>

<style>
	/* A phrase that wraps keeps the full mark on each of its lines. */
	.mark {
		padding: 1px 3px;
		background: var(--blue-100);
		color: var(--blue-800);
		font-weight: 600;
		-webkit-box-decoration-break: clone;
		box-decoration-break: clone;
	}
</style>
